import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import Popup, { PopupSize } from 'components/popup/Popup'
import { useTranslation } from 'react-i18next'
import './ConfirmReplacePopup.scss'
import { IBuffetDishDto } from 'core/api/dto/BuffetDishDto'
import { IPlanMenuControlDimensionDto } from 'core/api/dto/PlanMenuControlDto'
import moment from 'moment'
interface IPopupProps {
  onCancel: () => void
  onConfirm: () => void
  newItem?: IBuffetDishDto
  oldItem?: IBuffetDishDto
  currentDimension?: IPlanMenuControlDimensionDto
}
export const ConfirmReplacePopup = ({
  oldItem,
  newItem,
  onConfirm,
  onCancel,
  currentDimension,
}: IPopupProps) => {
  const { t } = useTranslation()
  return (
    <Popup size={PopupSize.md} borderRadiusMin>
      <div className="confirm-popup__container">
        <div className="confirm-popup__header">{t('Предупреждение')}</div>
        <div className="confirm-popup__main">
          <p className="confirm-popup__text">
            {t(
              `Вы действительно хотите заменить блюдо в замере от  ${moment.parseZone(
                currentDimension?.dimensionDatetime,
              ).format('DD.MM.YYYY HH:mm')} `,
            )}
          </p>

          <div className="confirm-field">
            <p className="confirm-label">Заменяемое блюдо</p>
            <p className="confirm-text">{oldItem?.name}</p>
          </div>
          <i className="an-ico an-ico-arrow-move" />
          <div className="confirm-field">
            <p className="confirm-label">Блюдо на замену</p>
            <p className="confirm-text">{newItem?.name}</p>
          </div>
        </div>
        <div className="buttons-block">
          <AppBtn
            title={t('Отменить')}
            color={AppBtnColor.outlineViolet}
            iconClassName="close"
            sized={AppBtnSize.md}
            onClick={onCancel}
          />
          <AppBtn
            title={t('Сохранить')}
            color={AppBtnColor.violetWhite}
            iconClassName="save"
            sized={AppBtnSize.md}
            onClick={onConfirm}
            // disabled={!currentItem}
          />
        </div>
      </div>
    </Popup>
  )
}
